import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _SubMacroProcess } from '../../../../core/services/dataBean/EntityCatalog';
import { _CustomProcessType } from '../../../../core/services/dataBean/EntityCatalogVdos';



interface Props {
    processType: number;
    idSelector: number;
    onChange: any;
    label?: string;
}

export const CustomProcessTypeSeleect = ({ idSelector, processType, onChange, label }: Props) => {

    const CustomProcessType = useDataBean(_CustomProcessType)
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(null);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector)
        }
    }, [])

    useEffect(() => {
        getLista();
    }, [processType])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {
        CustomProcessType.instance.getCustomProcessTypeCatalogByProcessType(processType).then(
            (resp) => {
                setLista(resp)
            }
        )
    }

    return (
        <>
            <label>{"Catálogo de Subprocesos"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null}>...</option>

                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDCustomProcessType}>{item.DataBeanProperties.Code} {item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}